module.exports = {
  title: '夕梦',
  // 页面路由保持在 admin-test 根路径，静态资源则可独立使用 CDN publicPath。
  loginUrl: (process.env.VUE_APP_ROUTER_BASE || process.env.BASE_URL) + 'login'
}
